import { Pipe, PipeTransform } from '@angular/core';
import { SgCountryService } from '../../services/country.service';

@Pipe({
  name: 'sgCountry',
  pure: true,
  standalone: false,
})
export class SgCountryPipe implements PipeTransform {
  constructor(private countryService: SgCountryService) {}

  transform(value: string, type: 'flag' | 'name' = 'name'): string {
    if (!value) {
      return value;
    }

    if (type === 'flag') {
      return this.countryService.getCountryFlag(value) || value;
    } else {
      return this.countryService.getCountryName(value) || value;
    }
  }
}
